module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/be075df9239fb217fba63a2314d27a6a.png";